import { BlockOutlined } from '@ant-design/icons';
import {
  ContentHoverEditButton,
  type ContentHoverEditButtonProps,
} from '@framework/ui/components/button/ContentHoverEditButton.tsx';
import styled from 'styled-components';
import { type IMapLayer } from '../layers/MapLayer.ts';

export interface IMapLayerItemProps
  extends Omit<ContentHoverEditButtonProps, 'children'> {
  layer: IMapLayer;
}

const MapLayerDiv = styled.div`
  padding: ${({ theme }) => theme.paddingSM}px;
  border: 1px solid ${({ theme }) => theme.colorBorder};
  border-radius: ${({ theme }) => theme.borderRadiusLG}px;
  margin-bottom: 4px;

  font-size: ${({ theme }) => theme.fontSizeLG}px;
  font-weight: 600;
`;

export function MapLayerItem(props: IMapLayerItemProps) {
  const { layer, ...rest } = props;
  return (
    <ContentHoverEditButton {...rest}>
      <MapLayerDiv>
        <div>
          <BlockOutlined /> {layer.name}
        </div>
      </MapLayerDiv>
    </ContentHoverEditButton>
  );
}
